import type {InfiniteData} from '@tanstack/react-query';

type BaseResultData<TData> = {
	results: TData[];
	startIndex: number;
	size: number;
};

export const getIndexedReactQueryResults = <TData>(
	data?: InfiniteData<BaseResultData<TData>>,
	extraParams?: Partial<TData>,
	stackData?: TData[],
	getData?: (d: TData) => TData,
) => {
	if (!data)
		return {
			data: [],
			total: 0,
		};

	const parsed: Array<TData & {index: number}> = stackData
		? stackData.map((d, index) => ({...d, index}))
		: [];

	data.pages.forEach(({results, startIndex}) => {
		results.forEach((result, index) => {
			parsed[startIndex + index] = {
				...(stackData || [])[startIndex + index],
				...result,
				index: startIndex + index,
				...extraParams,
				...(getData ? getData(result) : {}),
			};
		});
	});

	// TODO: what do we do when/if total changes?
	// refetch from beginning? because we can't always know where those new ones came from
	const total = data.pages[data.pages.length - 1]?.size || 0;

	return {
		data: parsed,
		total,
	};
};

export default getIndexedReactQueryResults;
